import React from 'react';
import { Tooltip, useMediaQuery } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import styles from './style.module.scss';
import { MUI_MOBILE_BREAKPOINT } from 'src/scripts/utils/constants';

interface ReshopMessagingProps {
  location?: 'cart' | 'pdp' | 'returnsPage';
}

const ReshopMessaging: React.FC<ReshopMessagingProps> = React.memo(({ location }) => {
  const { tooltipTextPdpCart, tooltipTextReturnsPage } = window.getSiteSettings().reshop;
  const [open, setOpen] = React.useState(false);
  const isMobile = useMediaQuery(MUI_MOBILE_BREAKPOINT);
  const isReturnsPage = location === 'returnsPage';
  const tooltipText = isReturnsPage ? tooltipTextReturnsPage : tooltipTextPdpCart;
  // show tooltip on top instead of bottom for mobile cart
  const placement = isMobile && location === 'cart' ? 'top' : 'bottom';

  const tooltipClose = () => {
    setOpen(false);
  };

  const tooltipOpen = () => {
    setOpen(true);
  };

  return (
    <span className={styles.reshop}>
      <span className={styles.logo}>
        <span className={`alo-reshop-logo-icon ${isReturnsPage ? 'returns-page-reshop-logo' : ''}`}></span>
      </span>
      {tooltipTextPdpCart || tooltipTextReturnsPage ? (
        <ClickAwayListener onClickAway={tooltipClose}>
          <Tooltip
            onClose={tooltipClose}
            open={open}
            arrow
            disableFocusListener
            disableHoverListener
            disableTouchListener
            classes={{
              popper: styles.reshopTooltip,
              tooltip: styles.tooltip,
              arrow: styles.arrow,
            }}
            title={<div dangerouslySetInnerHTML={{ __html: tooltipText }} />}
            placement={placement}
          >
            <span className={styles.info} onClick={tooltipOpen}>
              <span className="alo-info-icon"></span>
            </span>
          </Tooltip>
        </ClickAwayListener>
      ) : null}
    </span>
  );
});

export default ReshopMessaging;
